
const testItems = [
    {code:'01', text:'農藥殘留'},
    {code:'02', text:'真菌毒素',
        details:[
            {code:'0201', text:'總黃麴毒素'},
            {code:'0202', text:'黃麴毒素M1'},
            {code:'0203', text:'赭麴毒素A'},
            {code:'0204', text:'棒麴毒素'},
            {code:'0205', text:'橘黴素'},
            {code:'0206', text:'伏馬毒素B1+B2'},
            {code:'0207', text:'脫氧雪腐鐮刀菌烯醇'},
            {code:'0208', text:'玉米赤黴毒素'}
        ]},
    {
        code: '03', text: '重金屬',
        details: [
            {code:'0301', text:'鉛'},
            {code:'0302', text:'鎘'},
            {code:'0303', text:'汞'},
            {code:'0304', text:'總砷'},
            {code:'0305', text:'無機砷'},
            {code:'0306', text:'錫'},
            {code:'0307', text:'銅'},
            {code:'0308', text:'銻'},
        ]
    },
    {
        code: '04', text: '微生物',
        details: [
            {code:'0401', text:'總生菌數'},
            {code:'0402', text:'腸桿菌科'},
            {code:'0403', text:'大腸桿菌群'},
            {code:'0404', text:'大腸桿菌'},
            {code:'0405', text:'沙門氏菌'},
            {code:'0406', text:'金黃色葡萄球菌'},
            {code:'0407', text:'金黃色葡萄球菌腸毒素'},
            {code:'0408', text:'單核球增多性李斯特菌'}
        ]
    },
    {
        code: '05', text: '防腐劑',
        details: [
            {code:'0501', text:'5項(酸類)'},
            {code:'0502', text:'7項(酯類)'},
            {code:'0503', text:'丙酸'}
        ]
    },
    {
        code: '06', text: '添加物',
        details: [
            {code:'0601', text:'二氧化硫'},
            {code:'0602', text:'過氧化氫'}
        ]
    },
    {code:'07', text:'3-單氯丙二醇'},
    {code:'08', text:'苯駢芘'},
    {
        code: '09', text: '動物用藥/抗生素',
        details: [
            {code:'0901', text:'氯黴素類抗生素'},
            {code:'0902', text:'四環黴素類'},
            {code:'0903', text:'硝基呋喃代謝物'},
            {code:'0904', text:'多重殘留分析48項'}
        ]
    },
    {
        code: '10', text: '油脂品質',
        details: [
            {code:'1001', text:'酸價'},
            {code:'1002', text:'過氧化價'},
            {code:'1003', text:'總極性物質'},
            {code:'1004', text:'芥酸'}
        ]
    },
    {code:'11', text:'產品外標示'},
    {code:'others', text:'其他'}
]

export default testItems;